import api_access from '../../../api/apiInstance';

/**
 * Fetch all fields for the provided loan
 * @param loanId
 */
export async function fetchFieldsByLoanId(loanId: string): Promise<any> {
  try {
    // let bearerToken = "";
    // const fetchToken = async () => {
    //   const authCode = localStorage.getItem("auth_code");
    //   if (authCode) {
    //     try {
    //       const tokenResponse = await fetchTokenApi(authCode);
    //       bearerToken= tokenResponse.access_token;
    //       localStorage.setItem("access_token", tokenResponse.access_token)
    //       return tokenResponse.access_token;
    //     } catch (error: any) {
    //       // updateErrorMessage(ERROR_MESSAGE, error ? error.response ? error.response.data ? error.response.data.errorCode : 400 : 400 : 400, ERROR_DESCRIPTION);
    //       console.error('Error fetching token:', error);
    //     }
    //   }
    // };
    // await fetchToken();
    const response = await api_access.get(`/v1/fields/${loanId}/all`);
    return response.data;
  } catch (error) {
    console.error('Error fetching fields for loan:', error);
    throw error;
  }
}
